import { useTheme } from '@/context/ThemeContext';

const ART = {
  'MMA': 'mma', 'Functional Training': 'functional', 'Iron Fit': 'iron-fit', 'Pilates': 'pilates',
  'Mind Ride': 'mind-ride', 'Massive Ride': 'massive-ride', 'Aerotensity': 'aerotensity', 'Aqua Aerobics': 'aqua',
  'Elderly Exercise': 'elderly', 'Energy Healing': 'energy-healing', 'Tabata': 'tabata', 'Zumba': 'zumba',
  'Strong Nation': 'strong-nation', 'Pregnancy Exercises': 'pregnancy', 'Step Training': 'step',
};

export const ProgramArt = ({ program, alt }) => {
  const { theme } = useTheme();
  const slug = ART[program.name];
  if (!slug) {
    return <img src={program.image_url} alt={alt} className="w-full h-full object-cover" />;
  }
  return (
    <div className={`program-art program-art-${theme}`} data-testid={`program-art-${slug}`}>
      <span className="program-art-ring" />
      <img
        src={`${process.env.PUBLIC_URL}/programs/${theme === 'light' ? 'light' : 'dark'}/${slug}.svg`}
        alt={alt}
        loading="lazy"
        className="program-art-icon"
      />
    </div>
  );
};
